import { render, staticRenderFns } from "./CheckPermission.vue?vue&type=template&id=4365385a&scoped=true&"
import script from "./CheckPermission.vue?vue&type=script&lang=js&"
export * from "./CheckPermission.vue?vue&type=script&lang=js&"
import style0 from "./CheckPermission.vue?vue&type=style&index=0&id=4365385a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4365385a",
  null
  
)

export default component.exports